import React, {useState,useEffect,useRef} from 'react'
import styled from 'styled-components'
import {itemAPI2} from "../../libs/api2";
import {PrintIcon} from "../../common/icons";
import EstimatePrint from "../layer/EstimatePrint";
import {setCookie} from "../../libs/cookie";

const ShareLayerReNew = (props) => {
    const [copyUrlPopFlag, setCopyUrlPopFlag] = useState(false);
    const [isUrl, setIsUrl] = useState('');
    const [isCopy, setIsCopy] = useState(false);
    const snsData = {
        title : '쇼핑 큐레이션 · 행복쇼핑',
        description: '행복쇼핑은 컴퓨터, 조립PC에 특화된 온라인 견적 가격비교 사이트 입니다. 안전구매시스템(전자보증,에스크로)을 갖춘 쇼핑몰, 미니샵의 최저 가격 정보를 보여드립니다. 쇼핑의 행복! 행복쇼핑',
        imageUrl: process.env.REACT_APP_TLD === 'kr'
            ? `https://cdnimg.happyshopping.kr/img_static/img_pres/_v3/kakao_002.jpg`
            :`https://cdnimg-${process.env.REACT_APP_TLD}.happyshopping.kr/img_static/img_pres/_v3/kakao_002.jpg`
    }
    const inputRef = useRef(null);
    const [isCloseHover, setIsCloseHover] = useState(false);
    const [printFlag, setPrintFlag] = useState(false);
    const [estimateIdx, setEstimateIdx] = useState(null);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.0.1/kakao.min.js';
        script.async = true;
        document.body.appendChild(script);
        createEstimate()
    }, []);

    const createEstimate = () => {
        if(props.domainName!=='shopping'){
            itemAPI2.setItemEstimate(props.mallInfo?.idx_b_manager).then((rst) => {
                if(rst?.data?.code===400){
                    setCookie('auth_token', '', new Date(0), '/', `.pping.${process.env.REACT_APP_TLD}`)
                    window.location.href = process.env.REACT_APP_SSO_URL
                }
                if (rst.data.result) {
                    const idx_est = rst.data.id?rst.data.id:''
                    setEstimateIdx(idx_est)
                    setIsUrl(`https://pc.pping.${process.env.REACT_APP_TLD}/est/${idx_est}`)
                }
            })
        }else{
            setIsUrl(window.location.href)
            setEstimateIdx('1')
        }
    }

    const onClickCopyHandler = () => {
        window.navigator.clipboard.writeText(isUrl)
        inputRef.current.select();
        setIsCopy(true)
    }

    const onClickSnsHandler = (flag) => {
        if(flag==='kakao'){
            if (!window.Kakao.isInitialized()) {
                window.Kakao.init('d98008c5b7924c032845dea5e5d12b26');
            }

            window.Kakao.Share.sendDefault({
                objectType: 'feed',
                content: {
                    title: snsData.title,
                    description: snsData.description,
                    imageUrl: snsData.imageUrl,
                    imageWidth: 800,
                    imageHeight: 400,
                    link: {
                        mobileWebUrl: isUrl,
                        webUrl: isUrl,
                    },
                },
                buttons: [
                    {
                        title: '행복쇼핑에서 보기',
                        link: {
                            mobileWebUrl: isUrl,
                            webUrl: isUrl,
                        },
                    },
                ],
            })
        }else if(flag==='line'){
            const text = encodeURIComponent(snsData.title)
            window.open(
                `http://line.me/msg/text/?${text} : ${isUrl}`,
                'snsPop',
                'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=600,height=500',
            )
        }else if(flag==='facebook'){
            window.open(
                `http://www.facebook.com/sharer/sharer.php?u=${isUrl}`,
                'snsPop',
                'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=500,height=600',
            )
        }else if(flag==='twitter'){
            const text = encodeURIComponent(snsData.title)
            window.open(
                `//twitter.com/share?text=${text}&url=${isUrl}`,
                'snsPop',
                'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=650,height=500',
            )
        }else if(flag==='band'){
            const text = encodeURIComponent(snsData.title)
            window.open(
                `https://band.us/plugin/share?body=${text}&route=${isUrl}`,
                'snsPop',
                'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=650,height=500',
            )
        }else if(flag==='url'){
            setCopyUrlPopFlag((prev)=>!prev);
        }else if(flag==='print'){
            setPrintFlag(true);
        }
    }

    const onCloseHoverHandler = () => {
        setIsCloseHover((prev)=>!prev)
    }

    const onClickPrintHandler = () => {
        setPrintFlag((prev)=>!prev)
    }
    return (
        <>
            <ShareWrap>
                {!estimateIdx&&props.domainName!=='shopping'?
                    <div className="loading">
                        <img
                            src="//cdnimg.happyshopping.kr/img_static/img_pres/_v5/happy_loading_5.gif"
                            alt="loading"
                        />
                    </div>
                    :
                    (
                        <ShareBox copyUrlPopFlag={copyUrlPopFlag}>
                            <ShareTop>
                                <div>
                                    <span>{!copyUrlPopFlag?'공유하기':'URL 복사하기'}</span>
                                    <span onClick={props.onClose} onMouseEnter={onCloseHoverHandler} onMouseLeave={onCloseHoverHandler}>
                                        {!isCloseHover?<i className='pc_icons_X_close'/>:<i className='pc_icons_X_close_hover'/>}
                                    </span>
                                </div>
                            </ShareTop>
                            {!copyUrlPopFlag?(
                                <ShareMiddle>
                                    <div className='ShareMiddleItem' onClick={()=>onClickSnsHandler('kakao')}>
                                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/share/sns_kakaotalk.png`} alt="카카오톡" />
                                        <span>카카오톡</span>
                                    </div>
                                    <div className='ShareMiddleItem' onClick={()=>onClickSnsHandler('line')}>
                                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/share/sns_line.png`} alt="라인"/>
                                        <span>라인</span>
                                    </div>
                                    <div className='ShareMiddleItem' onClick={()=>onClickSnsHandler('facebook')}>
                                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/share/sns_facebook.png`} alt="페이스북" />
                                        <span>페이스북</span>
                                    </div>
                                    <div className='ShareMiddleItem' onClick={()=>onClickSnsHandler('twitter')}>
                                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/share/sns_twitter.png`} alt="트위터" />
                                        <span>트위터</span>
                                    </div>
                                    <div className='ShareMiddleItem' onClick={()=>onClickSnsHandler('band')}>
                                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/share/sns_band.png`} alt="밴드" />
                                        <span>밴드</span>
                                    </div>
                                    <div className='ShareMiddleItem' onClick={()=>onClickSnsHandler('url')}>
                                        <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/share/url.png`} alt="URL복사" />
                                        <span>URL복사</span>
                                    </div>
                                    {props.domainName!=='shopping'&&
                                        (<div className='ShareMiddleItem' onClick={()=>onClickSnsHandler('print')}>
                                            <PrintIcon size='60'/>
                                            <span>견적인쇄</span>
                                        </div>)
                                    }
                                    {/*<div><img src='' alt='' /><span>이메일</span></div>*/}
                                </ShareMiddle>
                            ):(
                                <>
                                    <UrlCopyBox >
                                        <CopyUrl type="text" readOnly="redonly" defaultValue={isUrl} ref={inputRef}/>
                                        <BtnUrlCopy type="button" onClick={onClickCopyHandler}>URL 복사</BtnUrlCopy>
                                    </UrlCopyBox>
                                    {isCopy &&
                                        <WrapperCopyCompelte>
                                            <CopyComplete>
                                                <li><span>·</span><span>URL이 복사되었습니다.</span></li>
                                                <li><span>·</span><span>복사 실패 시, 주소를 Ctrl+C 하고 붙여넣을 곳에 Ctrl+V 하세요.</span></li>
                                            </CopyComplete>
                                        </WrapperCopyCompelte>
                                    }
                                </>
                            )}
                            <ShareBottom copyUrlPopFlag={copyUrlPopFlag}>
                                <span onClick={props.onClose}>확인</span>
                            </ShareBottom>
                        </ShareBox>
                    )
                }

            </ShareWrap>
            {printFlag && <EstimatePrint onClickPrintHandler={onClickPrintHandler} priceType={props.priceType} estimateIdx={estimateIdx} minishopIdx={props.mallInfo?.idx_b_manager} />}
        </>
    )
}
export default ShareLayerReNew

const ShareWrap = styled.div`
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: bold;
    color:#333333;

    position:fixed;
    z-index:999;
    top:0;left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.75);

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 160px;
        position:fixed;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        &>img {
            width: 60px;
            height: auto;
        }
    }
`
const ShareBox = styled.div`
    width:${props => props.copyUrlPopFlag?'424px':''};
    background:#FFFFFF;
    border:2px solid #333333;

    position:absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`
const ShareTop = styled.div`
    padding:16px 20px 0 20px;
    &>div{
        border-bottom:1px solid #333333;
        display:flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom:14px;
    }
    &>div>span:nth-of-type(1){font-size:20px;line-height:29px;}
    &>div>span:nth-of-type(2){font-size:31px;line-height:29px;cursor:pointer;}
`
const ShareMiddle = styled.div`
    padding:28px 20px 0 20px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    row-gap: 16px;
    column-gap: 22px;
    &>div.ShareMiddleItem:hover{color:#418DED;cursor:pointer;}
    &>div.ShareMiddleItem{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align:center;
        img{
            margin-bottom: 5px;
            width: 60px;
            height: 60px;
        }
        i{
            margin-bottom: 5px;
        }
        &>span{font-size:14px;font-weight:400;line-height:22px;letter-spacing:-0.77px;}
    }
`
const ShareBottom = styled.div`
    padding:23px 20px 32px 20px;
    display:flex;
    justify-content:center;
    align-items:center;
    &>span:hover{background:#F6F6F6;cursor:pointer;}
    &>span{
        display:inline-block;
        border:2px solid #418DED;
        color:#418DED;
        font-size:16px;
        line-height:24px;
        padding:${props=>props.copyUrlPopFlag?'10px 78px':'10px 36px'};
    }
`





const UrlCopyBox = styled.div`
    display: flex;
    width: 100%;
    padding: 30px 20px 0 20px;

`
const CopyUrl = styled.input`
    display: inline-block;
    width: 100%;
    height: 30px;
    padding: 6px 8px;
    font-size: 12px;
    border: 1px solid #999 !important;
    border-right:none !important;
    color: #333333;
    background-color: #fff;
    vertical-align: middle;
    letter-spacing: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
const BtnUrlCopy = styled.span`
    white-space:nowrap;
    font-weight:400;
    padding:6px 14px;
    display: inline-block;
    font-size: 12px;
    border: none;
    color: #fff;
    background: #418DED;
    text-align: center;
    vertical-align: middle;
    letter-spacing: 0;
    cursor: pointer;
    line-height:17px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    text-align: center;
`

const WrapperCopyCompelte = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    padding:16px 0 0 20px;
`
const CopyComplete = styled.ul`
    font-size: 12px;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 3px;

    li {
        display: flex;
        gap: 2px;
    }

    li:nth-of-type(1) {
        color: #333;
    }
    li:nth-of-type(2) {
        color: #999;
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/share/shareLayerReNew.js